import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureUsageHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/admin/visual-game/usage' })
}

function usageHttp() {
  if (!http) throw new Error('configureUsageHttp must be called before usage API use')
  return http
}

export function listUsageCalls(query) {
  return usageHttp().get('/calls', { query, routeId: 'GET /api/admin/visual-game/usage/calls' })
}

export function fetchUsageFacets(query) {
  return usageHttp().get('/facets', { query, routeId: 'GET /api/admin/visual-game/usage/facets' })
}

export function getUsageCall(capability, id) {
  return usageHttp().get(`/calls/${capability}/${encodeURIComponent(id)}`, {
    routeId: 'GET /api/admin/visual-game/usage/calls/:capability/:id',
  })
}

export function fetchUsageCostOverview(query) {
  return usageHttp().get('/cost/overview', { query, routeId: 'GET /api/admin/visual-game/usage/cost/overview' })
}

export function fetchUsageCostByTime(query) {
  return usageHttp().get('/cost/by-time', { query, routeId: 'GET /api/admin/visual-game/usage/cost/by-time' })
}

export function fetchUsageCostByModel(query) {
  return usageHttp().get('/cost/by-model', { query, routeId: 'GET /api/admin/visual-game/usage/cost/by-model' })
}

export function fetchUsageCostByUser(query) {
  return usageHttp().get('/cost/by-user', { query, routeId: 'GET /api/admin/visual-game/usage/cost/by-user' })
}

export function fetchUsageCostByBillingMode(query) {
  return usageHttp().get('/cost/by-billing-mode', {
    query,
    routeId: 'GET /api/admin/visual-game/usage/cost/by-billing-mode',
  })
}
